import { gql } from '@apollo/client';

export const deleteUserAccountSecure = gql`
  mutation DeleteAccount($input: DeleteUserAccountInput!) {
    deleteUserAccountSecure(input: $input) {
      success
      message
      userId
    }
  }
`;